import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

export function getMinimumRepaymentIntervalAmount(state: RootState) {
    return _.get(
        state,
        'api.rbl_estimated_schedule.data.summary.minimum_repayments.interval.amount'
    );
}

export function getFees(state: RootState) {
    return _.get(state, 'api.rbl_estimated_schedule.data.summary.total_fees');
}

export function getTotalRepaymentAmount(state: RootState) {
    return _.get(
        state,
        'api.rbl_estimated_schedule.data.summary.total_payable'
    );
}

export function getRevenueStreamTags(state: RootState) {
    return _.get(
        state,
        'api.rbl_estimated_schedule.data.summary.repayment_revenue_stream_tags',
        []
    );
}

export function getEstimatedRepayments(state: RootState) {
    return _.get(
        state,
        'api.rbl_estimated_schedule.data.estimated_schedule.repayments',
        []
    );
}
